/**
 * @group Enums

@summary
<blockquote>Health record upload status lifecycle states.</blockquote>

@example
```typescript
const status: UploadStatus = UPLOAD_STATUSES.SUCCESS;
// 'success'
```
 * @internal
 */
export const UploadStatusEnum = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  SUCCESS: 'success',
  FAILED: 'failed',
  RETRYING: 'retrying',
} as const;
